import { render } from 'preact';
import './styles/index.css';
import { App } from './App';

// Registration is best-effort: a service worker needs a secure context, so it
// silently does nothing on a plain-http LAN address. The app works either way;
// only offline *reload* depends on it.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');
render(<App />, root);

/** The launch splash lives in index.html. Hold it long enough to read as a
 *  launch rather than a flicker, counted from navigation start so a slow
 *  bundle load is not added on top, then fade it and remove it. */
const SPLASH_MIN_MS = 700;
const splash = document.getElementById('splash');
if (splash && document.documentElement.classList.contains('launching')) {
  setTimeout(() => {
    splash.classList.add('leaving');
    const done = () => {
      splash.remove();
      document.documentElement.classList.remove('launching');
    };
    splash.addEventListener('transitionend', done, { once: true });
    // Reduced motion has no transition, so no transitionend.
    setTimeout(done, 400);
  }, Math.max(0, SPLASH_MIN_MS - performance.now()));
} else {
  splash?.remove();
}
